export const CHANGE_ROOT_COMPANY = "CHANGE_ROOT_COMPANY";
export const CHANGE_ROOT_COMPANY_LEVEL = "CHANGE_ROOT_COMPANY_LEVEL";
export const CHANGE_CUSTOM_RESOURCE_LIMITS = "CHANGE_CUSTOM_RESOURCE_LIMITS";
export const TRIGGER_ROOT_COMPANY = "TRIGGER_ROOT_COMPANY";
export const RELOAD_ITEMS = "RELOAD_ITEMS";
export const REMOVE_RECURRING_RELOAD = "REMOVE_RECURRING_RELOAD";
export const RESET_ALL_PARAMS = "RESET_ALL_PARAMS";
export const RESET_FILTER_PARAMS = "RESET_FILTER_PARAMS";
export const SET_COMPANY_FILTERED_VALUES = "SET_COMPANY_FILTERED_VALUES";
export const SET_FILTERED_VALUES = "SET_FILTERED_VALUES";
export const SET_QUERY_PARAMS = "SET_QUERY_PARAMS";
export const SET_RESOURCE = "SET_RESOURCE";
export const TOGGLE_TABLE_ROW_DESELECTION = "TOGGLE_TABLE_ROW_DESELECTION";
export const UPDATE_FILTER_PARAMS = "UPDATE_FILTER_PARAMS";
